import { NetworkStatus } from '@apollo/client';
import { AsyncStatus } from '../../../common/public';
export const getAsyncStatusFromNetworkStatus = networkStatus => {
  switch (networkStatus) {
    case NetworkStatus.ready:
      return AsyncStatus.SUCCEEDED;
    case NetworkStatus.loading:
    case NetworkStatus.refetch:
      return AsyncStatus.INITIAL_FETCH_LOADING;
    case NetworkStatus.fetchMore:
      return AsyncStatus.PAGINATED_FETCH_LOADING;
    case NetworkStatus.error:
      return AsyncStatus.FAILED;
    case NetworkStatus.poll:
      return AsyncStatus.SUCCEEDED;
    // Polling doesn't change UI state
    case NetworkStatus.setVariables:
      return AsyncStatus.INITIAL_FETCH_LOADING;
    default:
      return AsyncStatus.UNINITIALIZED;
  }
};